export const PLUGINS_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            left: "flex items-center gap-3",
            iconBox: "w-12 h-12 rounded-2xl flex items-center justify-center bg-violet-100",
            titleGroup: "",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-0.5",
        },
        searchWrapper: "relative",
        searchIcon: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400",
        searchInput: "w-[300px] pl-9 pr-4 h-10 bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 hover:border-[#7C3AED]/50 transition-all text-sm rounded-xl",
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-4 gap-3",
        card: "bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center",
        value: "text-xl font-bold text-gray-900",
        label: "text-xs text-gray-500",
    },
    tabs: {
        container: "flex items-center gap-1 bg-white rounded-xl border border-gray-100 p-1 w-fit",
        tab: "px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 cursor-pointer",
        tabActive: "bg-[#7C3AED] text-white shadow-sm shadow-[#7C3AED]/20",
        tabInactive: "text-gray-500 hover:text-gray-900 hover:bg-gray-50",
    },
    grid: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
    card: {
        container: "group bg-white rounded-xl border border-gray-100 hover:shadow-lg hover:border-[#7C3AED]/20 transition-all duration-300 cursor-pointer overflow-hidden flex flex-col relative",
        installedRibbon: "absolute top-3 right-3 z-10",
        header: "p-5 pb-3 flex items-start gap-4",
        iconBox: "w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm",
        info: "flex-1 min-w-0",
        nameRow: "flex items-center gap-2 flex-wrap",
        name: "text-sm font-bold text-gray-900",
        description: "text-xs text-gray-500 mt-1.5 line-clamp-2 leading-relaxed",
        footer: "px-5 pb-4 pt-2 mt-auto flex items-center justify-between border-t border-gray-50",
        price: "text-xs font-medium text-gray-400",
        action: "text-xs font-semibold text-[#7C3AED] opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center gap-1",
    },
    badge: {
        plan: {
            plus: "px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-violet-100 text-violet-700",
            essencial: "px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-blue-100 text-blue-700",
            mini: "px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-green-100 text-green-700",
        },
        installed: "flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-green-50 text-green-600 border border-green-200",
        notInstalled: "flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-gray-50 text-gray-400 border border-gray-200",
        category: "px-2.5 py-1 text-[11px] font-medium rounded-lg cursor-pointer transition-all duration-200",
    },
    emptyState: {
        container: "flex flex-col items-center justify-center p-16 bg-white rounded-xl border border-gray-100 border-dashed text-center",
        iconBox: "w-20 h-20 bg-violet-50 rounded-2xl flex items-center justify-center mb-5",
        title: "text-lg font-bold text-gray-900 mb-2",
        subtitle: "text-sm text-gray-500 max-w-sm",
    },
    loading: {
        container: "flex flex-col items-center justify-center py-24",
    },
    modal: {
        backdrop: "fixed inset-0 z-[9999] bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200",
        panel: "fixed inset-0 z-[9999] flex items-center justify-center p-4",
        container: "bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col animate-in fade-in zoom-in-95 duration-300 overflow-hidden",
        header: {
            container: "flex items-start gap-5 p-6 pb-4 border-b border-gray-100",
            iconBox: "w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md",
            info: "flex-1 min-w-0",
            name: "text-xl font-bold text-gray-900",
            badgeRow: "flex items-center gap-2 mt-2 flex-wrap",
            developer: "text-sm text-gray-500 mt-2",
            close: "p-2 rounded-xl hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0",
        },
        body: "flex-1 overflow-y-auto px-6 py-5",
        section: {
            container: "mb-5 last:mb-0",
            title: "text-xs font-semibold uppercase tracking-wider text-gray-400 mb-3",
            card: "bg-gray-50 rounded-xl p-4",
        },
        permissionsGrid: "grid grid-cols-1 md:grid-cols-2 gap-3",
        permissionItem: "text-sm text-gray-600 flex items-center gap-2.5 py-1",
        description: "text-sm text-gray-700 leading-relaxed",
        featureItem: "text-sm text-gray-600 flex items-center gap-2.5 py-1",
        footer: {
            container: "border-t border-gray-100 bg-gray-50/80 px-6 py-4 flex items-center justify-between",
            left: "flex items-center gap-3",
            installBtn: "flex items-center gap-2 px-5 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95",
            uninstallBtn: "flex items-center gap-2 px-5 py-2.5 bg-white hover:bg-red-50 text-red-600 text-sm font-medium rounded-xl transition-all border border-red-200 active:transform active:scale-95",
        },
    },
};
